module.exports = __webpack_public_path__ + "img/star1yellow.4c9966f2.png";